import {
  KoForm,
  KoFormBuilder,
  KoInput,
  KoMonaco,
  KoSelect,
  KoSwitch
} from 'packages';
import { useState } from 'react';
import {
  HTTP_METHOD_OPTIONS,
  ENDPOINT_STATUS_OPTIONS,
  AUTH_TYPE_OPTIONS
} from '../../constants';

function EndpointCrud({ form, handleFinish, services = [] }) {
  const [requestSchema, setRequestSchema] = useState('');
  const [responseSchema, setResponseSchema] = useState('');

  const MethodWidget = ({ value, onChange }) => (
    <KoSelect value={value} onChange={onChange} placeholder='HTTP Method' options={HTTP_METHOD_OPTIONS} />
  );

  const ServiceWidget = ({ value, onChange }) => (
    <KoSelect value={value} onChange={onChange} placeholder='Select service' options={services} allowClear />
  );

  const StatusWidget = ({ value, onChange }) => (
    <KoSelect value={value} onChange={onChange} placeholder='Select status' options={ENDPOINT_STATUS_OPTIONS} />
  );

  const AuthWidget = ({ value, onChange }) => (
    <KoSelect value={value} onChange={onChange} placeholder='Auth type' options={AUTH_TYPE_OPTIONS} />
  );

  const AuthRequiredWidget = ({ value, onChange }) => (
    <KoSwitch checked={value} onChange={onChange} />
  );

  const DeprecatedWidget = ({ value, onChange }) => (
    <KoSwitch checked={value} onChange={onChange} />
  );

  const handleFormFinish = (values) => {
    handleFinish({
      ...values,
      requestSchema: requestSchema || values.requestSchema,
      responseSchema: responseSchema || values.responseSchema
    });
  };

  const meta = {
    columns: 4,
    formItemLayout: null,
    colon: true,
    fields: [
      { key: 'service', label: 'Service', colSpan: 2, widget: ServiceWidget, forwardRef: true, required: true },
      { key: 'method', label: 'Method', colSpan: 1, widget: MethodWidget, forwardRef: true, required: true },
      { key: 'status', label: 'Status', colSpan: 1, widget: StatusWidget, forwardRef: true },
      { key: 'path', label: 'Path', colSpan: 2, widget: KoInput, required: true, widgetProps: { placeholder: '/api/v1/users/:id' } },
      { key: 'summary', label: 'Summary', colSpan: 2, widget: KoInput, widgetProps: { placeholder: 'Get user by ID' } },
      { key: 'authType', label: 'Auth Type', colSpan: 1, widget: AuthWidget, forwardRef: true },
      { key: 'authRequired', label: 'Auth Required', colSpan: 1, widget: AuthRequiredWidget, forwardRef: true },
      { key: 'deprecated', label: 'Deprecated', colSpan: 1, widget: DeprecatedWidget, forwardRef: true },
      { key: 'tags', label: 'Tags', colSpan: 1, widget: KoInput, widgetProps: { placeholder: 'Comma-separated' } },
      { key: 'description', label: 'Description', colSpan: 4, widget: KoInput.TextArea, widgetProps: { rows: 2, placeholder: 'Endpoint description...' } }
    ]
  };

  return (
    <KoForm form={form} layout='vertical' onFinish={handleFormFinish}>
      <KoFormBuilder form={form} meta={meta} />
      <div style={{ marginTop: '1.2rem' }}>
        <div style={{ marginBottom: '0.6rem', fontWeight: 600, fontSize: '1.2rem' }}>Request Schema (JSON)</div>
        <div style={{ border: '1px solid var(--border)', borderRadius: '0.6rem', overflow: 'hidden', minHeight: '14rem' }}>
          <KoMonaco
            language='json'
            JSONdata={requestSchema || form.getFieldValue('requestSchema') || ''}
            editorOnChange={(val) => setRequestSchema(val)}
          />
        </div>
      </div>
      <div style={{ marginTop: '1.2rem' }}>
        <div style={{ marginBottom: '0.6rem', fontWeight: 600, fontSize: '1.2rem' }}>Response Schema (JSON)</div>
        <div style={{ border: '1px solid var(--border)', borderRadius: '0.6rem', overflow: 'hidden', minHeight: '14rem' }}>
          <KoMonaco
            language='json'
            JSONdata={responseSchema || form.getFieldValue('responseSchema') || ''}
            editorOnChange={(val) => setResponseSchema(val)}
          />
        </div>
      </div>
    </KoForm>
  );
}

export default EndpointCrud;
